module.exports = __webpack_public_path__ + "static/media/4644.3838d55c.jpg";